import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["panel", "frame", "title"]

  open(event) {
    event.preventDefault()
    // The iframe always loads HTML now — an attachment list, the PDF.js viewer
    // page (public/pdfjs/viewer.html, for PDFs), or an image — never a raw PDF,
    // so it renders on every platform incl. the installed PWA. Callers wrap PDF
    // URLs via the pdfjs_viewer_path helper.
    this.frameTarget.src = event.currentTarget.dataset.contractUrl
    this.titleTarget.textContent = event.currentTarget.dataset.contractLabel
    this.panelTarget.hidden = false
  }

  close() {
    this.panelTarget.hidden = true
    this.frameTarget.src = ""
    this.titleTarget.textContent = ""
  }
}
